<section>
    <div class="container d-lg-flex align-items-start">
        <div class="contact-us-form">
            <form #f="ngForm" ngForm="form" (submit)="save()">
                <label for="name" class="uc-custom-hidden">{{ 'unifiedForms.labels.name' | translate }} <span class="text-danger" aria-hidden="true">*</span></label>
                <input type="text" id="name" autocomplete="name" aria-required="true" name="name" class="form-control shadow-none" [(ngModel)]="model.name" required placeholder="{{'contactUs.enterName' | translate}}"/>
                <label for="email" class="uc-custom-hidden">{{ 'unifiedForms.labels.email' | translate }} <span class="text-danger" aria-hidden="true">*</span></label>
                <input [ngClass]="{'email-invalid' : emailNotValid}" type="email" id="email" autocomplete="email" aria-required="true"
                    [attr.aria-invalid]="emailNotValid ? 'true' : null" [attr.aria-describedby]="emailNotValid ? 'contactEmailError' : null" name="email" class="form-control shadow-none" [(ngModel)]="model.email"  required placeholder="{{'contactUs.enterEmail' | translate}}"/>
                <p *ngIf="emailNotValid" id="contactEmailError" role="alert" class="uc-field-error uc-custom-hidden">{{ 'unifiedForms.invalidEmail' | translate }}</p>
                <label for="message" class="uc-custom-hidden">{{ 'unifiedForms.labels.message' | translate }} <span class="text-danger" aria-hidden="true">*</span></label>
                <textarea class="form-control shadow-none" id="message" aria-required="true" name="message" [(ngModel)]="model.message" required placeholder="{{'contactUs.writeYourMessage' | translate}}"></textarea>
                <p *ngIf="sent" role="status" class="text-center text-success uc-form-success" translate="contactUs.success"></p>
                <button [disabled]="!f.valid" type="submit" class="btn uc-btn-primary shadow-none border-0 text-white d-flex align-items-center justify-content-center" translate="contactUs.sendMessage"></button>
            </form>
            <div>
                <p translate="contactUs.socialMedia"></p>
                <div class="d-flex align-items-center justify-content-center">
                    <a (click)="getContactValue(ContactInfoType.LinkedIn, true)" target="_blank" class="uc-no-ext" *ngIf="checkContactTypeExist(ContactInfoType.LinkedIn)" [href]="'javascript:void()'">
                        <span class="visually-hidden">LinkedIn</span>
                        <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../assets/imgs/linkedin.svg);"></span>
                    </a>
                    <a (click)="getContactValue(ContactInfoType.Twitter, true)" target="_blank" class="uc-no-ext" *ngIf="checkContactTypeExist(ContactInfoType.Twitter)" [href]="'javascript:void()'">
                        <span class="visually-hidden">X</span>
                        <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../assets/imgs/twitter.svg);"></span>
                    </a>
                    <a (click)="getContactValue(ContactInfoType.Instagram, true)" target="_blank" class="uc-no-ext" *ngIf="checkContactTypeExist(ContactInfoType.Instagram)" [href]="'javascript:void()'">
                        <span class="visually-hidden">Instagram</span>
                        <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../assets/imgs/instagram.svg);"></span>
                    </a>
                    <a (click)="getContactValue(ContactInfoType.Facebook, true)" target="_blank" class="uc-no-ext" *ngIf="checkContactTypeExist(ContactInfoType.Facebook)" [href]="'javascript:void()'">
                        <span class="visually-hidden">Facebook</span>
                        <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../assets/imgs/facebook.svg);"></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="contact-us-info">
            <div>
                @if (isUnified) {
                <h1 class="uc-display-xs uc-bold" translate="contactUs.contactUs"></h1>
                } @else {
                <h3 translate="contactUs.contactUs"></h3>
                }
                <p translate="contactUs.contactInfo"></p>
                <div class="d-lg-flex align-items-center">
                    <ul>
                        <li *ngIf="checkContactTypeExist(ContactInfoType.AddressAr) || checkContactTypeExist(ContactInfoType.AddressEn)" class="d-flex align-items-start">
                            <img alt="" loading="lazy" src="assets/imgs/contact-us-location.svg"/>
                            <div>
                                <h6 translate="contactUs.location"></h6>
                                <p class="mb-0">{{isRtl ? getContactValue(ContactInfoType.AddressAr) : getContactValue(ContactInfoType.AddressEn)}}</p>
                            </div>
                        </li>
                        <li *ngIf="checkContactTypeExist(ContactInfoType.Email)" class="d-flex align-items-start">
                            <img alt="" loading="lazy" src="assets/imgs/contact-us-email.svg"/>
                            <div>
                                <h6 translate="contactUs.email"></h6>
                                <p class="mb-0" *ngFor="let email of emailList">{{email.description}}: {{email.title}}</p>
                            </div>
                        </li>
                        <li *ngIf="checkContactTypeExist(ContactInfoType.Phone)" class="d-flex align-items-start">
                            <img alt="" loading="lazy" src="assets/imgs/contact-us-phone.svg"/>
                            <div>
                                <h6 translate="contactUs.contact"></h6>
                                <p class="mb-0" *ngFor="let phone of phoneList">{{phone.description}}: {{phone.title}}</p>
                            </div>
                        </li>
                        <li *ngIf="checkContactTypeExist(ContactInfoType.Fax)" class="d-flex align-items-start">
                            <img alt="" loading="lazy" src="assets/imgs/contact-us-fax.svg"/>
                            <div>
                                <h6 translate="contactUs.fax"></h6>
                                <p class="mb-0">{{getContactValue(ContactInfoType.Fax)}}</p>
                            </div>
                        </li>
                        <li *ngIf="checkContactTypeExist(ContactInfoType.WhatsApp)" class="d-flex align-items-start">
                            <img alt="" loading="lazy" src="assets/imgs/contact-us-whatsApp.svg"/>
                            <div>
                                <h6 translate="contactUs.whatsApp"></h6>
                                <p class="mb-0">{{getContactValue(ContactInfoType.WhatsApp)}}</p>
                            </div>
                        </li>
                    </ul>
                    <img alt="" class="d-none d-lg-block" loading="lazy" src="assets/imgs/contact-us.svg"/>
                </div>
            </div>
        </div>
    </div>
</section>